import styled, { css } from 'styled-components';
import { FC, useEffect, PropsWithChildren } from 'react';
import { ScreenScrapeCloseButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeCloseButton';
import { media } from 'src/common/styles/breakpoints';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { useBeforeSSUnload } from 'src/pages/AspspSelectPage/ScreenScrape/useBeforeSSUnload';
import { MessageCode } from 'src/common/models/message';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 50vh;

  ${media.w.min.px576(css`
    min-height: 27.5rem;
  `)}
`;

const Logo = styled.img`
  object-fit: contain;
  height: 4.5rem;

  ${media.w.min.px576(css`
    height: 6.25rem;
  `)}
`;

const TopWrapper = styled.div`
  min-height: 3rem;
  display: flex;
  justify-content: flex-end;
`;

export interface ScreenScrapeLayoutProps extends PropsWithChildren {
  logo?: string | null;
}

export const ScreenScrapeLayout: FC<ScreenScrapeLayoutProps> = ({
  children,
  logo,
}) => {
  const ctx = useSSContext();
  useBeforeSSUnload();

  useEffect(() => {
    if (ctx.lastJsonMessage?.messageCode === MessageCode.CancelProcess) {
      ctx.closeModal();
    }
  }, [ctx.lastJsonMessage]);

  const isCloseButtonVisible =
    !ctx.isLoading &&
    (!ctx.lastJsonMessage ||
      ![
        MessageCode.DownloadingTransactions,
        MessageCode.DownloadingUserInformation,
        MessageCode.AmlPopup,
        MessageCode.ConfirmTransactionDownload,
        MessageCode.Logout,
        MessageCode.Error,
      ].includes(ctx.lastJsonMessage.messageCode));

  return (
    <Container>
      <TopWrapper>
        {isCloseButtonVisible && (
          <ScreenScrapeCloseButton
            disabled={ctx.isLoading}
            onClose={() => {
              ctx.cancelProcess();
            }}
          />
        )}
      </TopWrapper>
      {logo && <Logo src={logo} />}
      <MainContent>
        {ctx.isUserReturningToProcess && !ctx.isFirstMessageReceived ? (
          <ScreenScrapeLoader />
        ) : (
          children
        )}
      </MainContent>
    </Container>
  );
};
